<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-22 
-->
<template>
  <div class="index">
    <div class="countdown-bar" v-if="showCountdown">
      <div class="countdown-inner">
        <div class="countdown-title">{{ countdownTitle }}</div>
        <div class="countdown-list">
          <div class="countdown-item" v-for="item in countdownList" :key="item.key">
            <div class="countdown-value">{{ item.value }}</div>
            <div class="countdown-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-pc" @click="clickBanner(banner)" v-if="banner.img">
      <img :src="banner.img" />
    </div>
    <div class="banner-pc" v-else></div>
    <!-- <div class="number-container" v-if="numberList.length && language == 'en'">
      <div :class="['number-list', numberList.length > 3 && 'number-list2']">
        <div class="number-item" v-for="item,index in numberList" :key="index">
          <div class="p1">
            <span class="sp1">{{item.number}}</span>
            <span class="sp2">{{item.unit}}</span>
          </div>
          <div class="p2">{{item.name}}</div>
        </div>
      </div>
    </div> -->
    <div class="index-container">
      <!-- <div class="page-view" v-if="mainPageContent.length">
        <div class="page-title">
          <p class="p1">会+展+榜 三大版块</p>
          <p class="p2">CONFERENCE+EXHIBITION+AWARDS</p>
        </div>
        <div class="ecological">
          <div class="item" v-for="item,index in mainPageContent" :key="index">
            <div class="img-cnt">
              <img :src="item.imgPath | logo_show" class="bg-img">
            </div>
            <div class="item-cnt">
              <img :src="static_img_url + `pic/sort`+(index + 1)+`.png`" class="sort-img" />
              <div class="title">
                <div v-if="language == 'zh'" v-html="item.showPageTitle"></div>
                <div v-else v-html="item.showEnPageTitle"></div>
              </div>
              <div class="desc">
                <div v-if="language == 'zh'" v-html="item.showContent"></div>
                <div v-else v-html="item.showEnContent"></div>
              </div>
              <div class="more-link" @click="handleClickPage(item.id, item.type)">{{'了解更多' | dealLanguage('More')}}</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="page-view reason-view">
        <div class="page-title">
          <p class="p1">{{'CSGCT 2026绝对不容错过' | dealLanguage('CSGCT Annual Meeting: Absolutely Unmissable')}}</p>
          <p class="reason-sub-title">{{'亚太地区最具国际影响力的细胞与基因治疗领域盛会' | dealLanguage('CSGCT Annual Meeting: Absolutely Unmissable')}}</p>
          <p class="p2"></p>
        </div>
        <div class="reason-list">
          <div class="reason-item" v-for="item,index in reasonList" :key="index">
            <i class="iconfont reason-icon" v-html="item.iconClass"></i>
            <div class="reason-title">{{item.title | dealLanguage(item.enTitle)}}</div>
            <div class="reason-desc">{{item.desc | dealLanguage(item.enDesc)}}</div>
          </div>
        </div>
        <swiper class="previous-swiper" :options="swiperOption" ref="previous-swiper">
          <swiper-slide v-for="item,index in previousList2" :key="index">
            <div class="previous-item">
              <img :src="`${static_img_url}pic/previous2/${index + 1}.png`" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="page-view">
        <div class="page-title">
          <p class="p1">{{'大会亮点' | dealLanguage('HIGHLIGHTS')}}</p>
          <p class="p2"></p>
        </div>
        <div class="high-light" v-if="language != 'en'">
          <img :src="`${static_img_url}pic/hl/hl.jpg`" />
        </div>
        <div class="high-light" v-else>
          <img :src="`${static_img_url}pic/hl/enhl.jpg`" />
        </div>
      </div>
      <div class="page-view" v-if="guestDtos.length">
        <div class="page-title">
          <p class="p1">{{'CSGCT核心专家库' | dealLanguage('PREVIOUS GUESTS')}}</p>
          <p class="p2"></p>
        </div>
        <div class="speakers">
          <speaker-item v-for="item,index in guestDtos" :key="index" :itemDetail="item"></speaker-item>
        </div>
        <!-- <div class="page-more">
          <div class="more-link" @click="handleChangeRoute('guests', '更多嘉宾')">更多嘉宾</div>
        </div> -->
      </div>
      <!-- <div class="page-view" v-if="activityExhibitionAreas.length">
        <div class="page-title">
          <p class="p1">特色展区</p>
          <p class="p2">FEATURED EXHIBITION AREA</p>
        </div>
        <div class="area">
          <div class="area-item" v-for="item,index in activityExhibitionAreas" :key="index">
            <div class="mask">
              <div class="more-btn" @click="handleClickAreas(item.id)">{{'查看更多' | dealLanguage('More')}}</div>
            </div>
            <div class="mask2"></div>
            <div class="title" @click="handleClickAreas(item.id)">{{item.title | dealLanguage(item.enTitle)}}</div>
            <img :src="item.imgPath | logo_show" class="bg-img" />
          </div>
        </div>
      </div> -->
      <div class="page-view" v-if="activityContentAppMiDtos.length">
        <div class="page-title">
          <p class="p1">{{'新闻资讯' | dealLanguage('NEWS')}}</p>
          <p class="p2"></p>
        </div>
        <div class="news">
          <news-item v-for="item,index in activityContentAppMiDtos" :key="index" :itemDetail="item"></news-item>
        </div>
        <div class="page-more">
          <div class="more-link" @click="handleChangeRoute('newsList', '更多新闻资讯')">{{'更多新闻资讯' | dealLanguage('More News')}}</div>
        </div>
      </div>
      <!-- <div class="page-view" v-if="language == 'en'">
        <div class="page-title">
          <p class="p1">{{'往届会议' | dealLanguage('PREVIOUS MEETING')}}</p>
          <p class="p2"></p>
        </div>
        <swiper class="previous-swiper" :options="swiperOption" ref="previous-swiper">
          <swiper-slide v-for="item,index in previousList" :key="index">
            <div class="previous-item">
              <img :src="`${static_img_url}pic/previous/${index + 1}.jpg`" />
            </div>
          </swiper-slide>
        </swiper>
      </div> -->
      <div class="page-view" v-if="orgDtos.length">
        <div class="page-title">
          <p class="p1">{{'合作媒体' | dealLanguage('MEDIA PARTNERS')}}</p>
          <p class="p2"></p>
        </div>
        <div class="entitys">
          <entity-item v-for="item,index in orgDtos" :key="index" :itemDetail="item"></entity-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SpeakerItem from '@/components/index/speakerItem.vue'
import NewsItem from '@/components/index/newsItem.vue'
import EntityItem from '@/components/index/entityItem.vue'
import { getActExhibition } from '@/service/vbef'
import { Aadvertisement } from '@/service/app'
import { mapState } from 'vuex'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? this.activityDetail.name : this.activityDetail.enName,
    }
  },
  inject: ['globalInsertRecords', 'clickBanner'],
  components: {
    SpeakerItem,
    NewsItem,
    EntityItem,
  },
  created() {
    this.getBanner()
    this.getActExhibition()
    // this.dealMainPageContent()
  },
  beforeDestroy() {
    this.clearCountdownTimer()
  },
  mounted() {},
  data() {
    return {
      numberList: [],
      // enNumberList: [],
      actExhibitionDto: {},
      activityContentAppMiDtos: [],
      activityExhibitionAreas: [],
      guestDtos: [],
      orgDtos: [],
      banner: {},
      showMainPageContent: [],
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 60,
        loop: true,
        autoplay: true,
      },
      previousList: Array(16),
      previousList2: Array(6),
      reasonList: [
        {
          title: '国际化：全球创新力量齐聚',
          enTitle: 'Global Reach: Uniting Innovation Worldwide',
          iconClass: '&#xe706;',
          desc:
            '300+国际顶尖嘉宾从学术奠基人到产业领袖，覆盖美国、欧洲、中东及东南亚等地区，携前沿视野与协作意向汇聚北京。专设中国IIT资源对接会与海外BD对接会，构建链接全球临床资源与跨境资本的直通平台。',
          enDesc:
            '300+ top-tier international speakers — from academic pioneers to industry leaders, covering the United States, Europe, the Middle East, Southeast Asia, and beyond — bringing cutting-edge perspectives and collaboration intent to Beijing. Featuring dedicated China IIT Resource Matchmaking Session and Overseas BD Matchmaking Session, building a direct platform linking global clinical resources and cross-border capital.',
        },
        {
          title: '监管与临床：权威解读与深度链接',
          enTitle: 'Regulatory & Clinical: Authoritative Insights & Deep Connections',
          iconClass: '&#xe705;',
          desc:
            '监管专家现场拆解IND/BLA加速路径、北医三院、北大肿瘤、协和等头部临床PI分享最新试验数据，关键临床设计思路及临床试验策略。',
          enDesc:
            'Regulatory experts decode IND/BLA acceleration pathways on site. Leading clinical PIs from Peking University Third Hospital, Peking University Cancer Hospital, Peking Union Medical College Hospital, and others share the latest trial data, key clinical design approaches, and clinical trial strategies.',
        },
        {
          title: '全产业链：关键决策者齐聚',
          enTitle: 'Full Industry Chain: Key Decision Makers Gather',
          iconClass: '&#xe707;',
          desc:
            '超70%的参会代表为决策层，包括CGT创新药企、大型药企、科研院所及临床机构等关键决策方覆盖研发立项、工艺选择到商业化推进的全链条。',
          enDesc:
            'Over 70% of the attendees are decision-makers, including key stakeholders from CGT innovative biotech companies, large pharmaceutical firms, research institutes, and clinical institutions — covering the entire value chain from R&D project initiation and process selection to commercial advancement.',
        },
        {
          title: '全谱系：前沿技术全覆盖',
          enTitle: 'Full Spectrum: Complete Coverage of Cutting-Edge Technologies',
          iconClass: '&#xe708;',
          desc:
            '体内CAR-T、小核酸、外泌体、iPSC等前沿技术分支全覆盖，23场分论坛细分投资、递送、CMC、AI赋能等交叉议题，探讨各赛道产业化的真实进展。',
          enDesc:
            'Full coverage of frontier technology branches including in vivo CAR-T, small nucleic acids, exosomes, iPSC, etc. 23 sub-forums spanning cross-cutting topics such as financing & investment, delivery, CMC, AI-enabled drug discovery, exploring the real-world progress of industrialization across different tracks.',
        },
      ],
      showCountdown: false,
      countdownTimer: null,
      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      mainPageContent: (state) => state.mainPageContent,
      language: (state) => state.language,
    }),
    countdownTitle() {
      return this.language == 'zh' ? '距离大会开始还有' : 'Countdown to Opening'
    },
    countdownList() {
      const labels =
        this.language == 'zh'
          ? { days: '天', hours: '时', minutes: '分', seconds: '秒' }
          : { days: 'Days', hours: 'Hours', minutes: 'Minutes', seconds: 'Seconds' }
      return [
        { key: 'days', value: this.countdown.days, label: labels.days },
        { key: 'hours', value: this.countdown.hours, label: labels.hours },
        { key: 'minutes', value: this.countdown.minutes, label: labels.minutes },
        { key: 'seconds', value: this.countdown.seconds, label: labels.seconds },
      ]
    },
  },
  watch: {
    'activityDetail.startTime': {
      immediate: true,
      handler(val) {
        this.initCountdown(val)
      },
    },
  },
  methods: {
    initCountdown(time) {
      this.clearCountdownTimer()
      const targetTime = this.parseCountdownTime(time)
      if (!targetTime) {
        this.showCountdown = false
        return
      }
      this.updateCountdown(targetTime)
      if (!this.showCountdown) return
      this.countdownTimer = setInterval(() => {
        this.updateCountdown(targetTime)
      }, 1000)
    },
    updateCountdown(targetTime) {
      const diff = targetTime - Date.now()
      if (diff <= 0) {
        this.showCountdown = false
        this.clearCountdownTimer()
        return
      }
      const totalSeconds = Math.floor(diff / 1000)
      const days = Math.floor(totalSeconds / 86400)
      const hours = Math.floor((totalSeconds % 86400) / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60
      this.countdown = {
        days: this.formatCountdownValue(days),
        hours: this.formatCountdownValue(hours),
        minutes: this.formatCountdownValue(minutes),
        seconds: this.formatCountdownValue(seconds),
      }
      this.showCountdown = true
    },
    parseCountdownTime(time) {
      if (!time) return 0
      const normalizedTime = String(time).replace(/-/g, '/')
      return new Date(normalizedTime).getTime()
    },
    formatCountdownValue(value) {
      return value > 9 ? String(value) : `0${value}`
    },
    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    dealMainPageContent() {
      this.showMainPageContent = [...this.mainPageContent]
      this.showMainPageContent.map((a) => {
        this.$set(a, 'showPageTitle', a.pageTitle.replace(/\n/g, '<br>'))
        this.$set(a, 'showEnPageTitle', a.enPageTitle.replace(/\n/g, '<br>'))
        this.$set(a, 'showContent', a.content.replace(/\n/g, '<br>'))
        this.$set(a, 'showEnContent', a.enContent.replace(/\n/g, '<br>'))
      })
    },
    async getBanner() {
      let res = await Aadvertisement({
        appAdPositionIds: this.language == 'zh' ? [127] : [125],
      })
      if (res.code == 0 && res.data.length) {
        this.$set(this.$data, 'banner', res.data[0])
      }
    },
    async getActExhibition() {
      let res = await getActExhibition({
        activityId: this.activityId,
        isEnglish: this.language == 'en' ? 1 : 0,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'actExhibitionDto', res.data.actExhibitionDto)

        this.$set(this.$data, 'activityContentAppMiDtos', res.data.activityContentAppMiDtos)
        this.$set(this.$data, 'activityExhibitionAreas', res.data.activityExhibitionAreas)
        this.$set(this.$data, 'guestDtos', res.data.guestDtos)
        this.$set(this.$data, 'orgDtos', res.data.orgDtos)
        // if (this.language == 'zh') {
        //   let fDtos = res.data.actExhibitionDto.featureJsonObjDtos || []
        //   if (fDtos.length > 0) {
        //     fDtos = fDtos.filter((item) => item.name && item.number)
        //   }
        //   this.$set(this.$data, 'numberList', fDtos)
        // } else {
        //   let fDtos = res.data.actExhibitionDto.enFeatureJsonObjDtos || []
        //   if (fDtos.length > 0) {
        //     fDtos = fDtos.filter((item) => item.name && item.number)
        //   }
        //   this.$set(this.$data, 'numberList', fDtos)
        // }
      }
    },

    handleClickPage(itemid, itemtype) {
      this.globalInsertRecords({
        contentId: itemid,
        contentType: 161,
        viewType: 1,
      })
      if (itemtype == 3) {
        window.open('https://vb100.vbdata.cn/Index/list', '_blank')
      } else if (itemtype == 1) {
        this.$router.push({ name: 'agenda' })
      } else {
        this.$router.push({ name: 'exhibitionDesc', params: { id: 83 } })
      }
    },

    handleClickAreas(itemid) {
      this.globalInsertRecords({
        contentId: itemid,
        contentType: 162,
        viewType: 1,
      })
      this.$router.push({ name: 'exhibitionDesc', params: { id: 2 } })
      // let index = this.mainPageContent.findIndex((item) => item.type == 2)
      // if (index > -1) {
      //   let current_id = this.mainPageContent[index].id
      // }
    },

    handleChangeRoute(name, kw) {
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: kw,
      })
      this.$router.push({ name })
    },
  },
}
</script>
<style lang='stylus' scoped>
.index
  min-width 1200px
.countdown-bar
  background linear-gradient(90deg, #c8161d 0%, #e94a08 100%)
  color #fff
  .countdown-inner
    width 1200px
    margin 0 auto
    min-height 88px
    display flex
    align-items center
    justify-content space-between
  .countdown-title
    font-size 30px
    line-height 42px
    font-weight 700
  .countdown-list
    display flex
    align-items center
  .countdown-item
    width 100px
    height 64px
    border-radius 12px
    background rgba(255, 255, 255, 0.14)
    display flex
    flex-direction column
    align-items center
    justify-content center
    & + .countdown-item
      margin-left 16px
  .countdown-value
    font-size 28px
    line-height 1
    font-weight 700
  .countdown-label
    margin-top 8px
    font-size 14px
    line-height 20px
.banner-pc
  height 720px
  background #f0f0f0
  display flex
  justify-content center
  overflow hidden
  cursor pointer
  img
    width auto
    height 100%
.number-container
  background #FFF2EB
  .number-list
    width 1200px
    margin 0 auto
    padding 25px 0
    display flex
    justify-content space-evenly
    &.number-list2
      justify-content space-between
    .number-item
      text-align center
      .p1
        font-family 'DINMittelschriftStd'
        color #C8161D
        line-height 72px
        .sp1
          font-size 60px
        .sp2
          font-size 40px
      .p2
        font-size 18px
        color #47515F
        line-height 25px
.index-container
  width 1200px
  margin 0 auto
  padding-bottom 50px
  .page-view
    padding-top 40px
    &+.page-view
      padding-top 100px
    .page-title
      .p1
        line-height 1
        font-size 30px
        color #333333
        text-align center
      .p2
        width 80px
        height 4px
        background #C8161D
        margin 20px auto 0
  .more-link
    font-size 16px
    color #c8161d
    line-height 28px
    border-bottom 2px solid #c8161d
    transition 0.3s
    cursor pointer
  .ecological
    margin-top 40px
    display flex
    justify-content center
    .item
      flex 0 0 360px
      max-width 360px
      min-width 360px
      background #FFFFFF
      box-shadow 0px 6px 16px 0px rgba(0, 0, 0, 0.1)
      display flex
      flex-direction column
      &+div
        margin-left 60px
      .img-cnt
        width 100%
        height 298px
        max-height 298px
        min-height 298px
        background #f0f0f0
        position relative
        .bg-img
          width 100%
          height 100%
          object-fit cover
      .item-cnt
        padding 70px 40px 106px
        position relative
        width 100%
        flex auto
        .sort-img
          position absolute
          height 40px
          left 40px
          top -10px
          z-index 2
        .more-link
          position absolute
          bottom 40px
          left 40px
        .item-sort
          position absolute
        .title
          font-size 20px
          color #47515F
          line-height 32px
          font-weight 700
        .desc
          font-size 14px
          color #666666
          line-height 28px
          margin-top 30px
  .speakers
    display flex
    flex-wrap wrap
    margin-top 30px
    >>> .speaker-item
      &:not(:nth-of-type(4n+1))
        margin-left 26px
      &:nth-of-type(n+5)
        margin-top 26px
  .high-light
    margin-top 40px
    img
      width 100%
  .reason-view
    .reason-sub-title
      margin-top 18px
      text-align center
      font-weight: 400;
      font-size: 22px;
      color: #333333;
      line-height: 26px;
    .reason-list
      margin-top 30px
      display grid
      grid-template-columns repeat(4, 1fr)
      gap 24px
    .reason-item
      background #FFFFFF
      border-radius 10px
      box-shadow 0 4px 18px rgba(0, 0, 0, 0.08)
      padding 20px
      position relative
      min-height 240px
      transition all 0.3s
      &:hover
        transform translateY(-4px)
        box-shadow 0 10px 28px rgba(200, 22, 29, 0.12)
      .reason-icon
        color #C8161D
        font-size 26px
      .reason-title
        margin-top 12px
        font-weight: 400;
        font-size: 16px;
        color: #C8161D;
        line-height: 26px;
      .reason-desc
        margin-top 10px
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
  .page-more
    margin-top 20px
    display flex
    justify-content center
  .area
    display flex
    flex-wrap wrap
    margin-top 30px
    .area-item
      flex 0 0 300px
      max-width 300px
      min-width 300px
      height 360px
      position relative
      overflow hidden
      .bg-img
        width 100%
        height 100%
        object-fit cover
      .title
        position absolute
        left 20px
        bottom 40px
        right 20px
        font-size 20px
        color #FFFFFF
        line-height 28px
        z-index 4
        cursor pointer
        transition all 0.3s
        &:hover
          opacity 0.9
      &:hover
        .mask
          opacity 1
          transform translateY(0)
      .mask2
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        background linear-gradient(360deg, rgba(0, 0, 0, 0.6) 0%, rgba(216, 216, 216, 0) 100%)
        z-index 2
      .mask
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        background rgba(78, 119, 223, 0.8)
        border-radius 0px 0px 0px 0px
        display flex
        align-items center
        justify-content center
        z-index 3
        opacity 0
        transform translateY(200px)
        transition all 0.3s
        .more-btn
          width 120px
          height 36px
          border 1px solid #FFFFFF
          font-size 14px
          color #FFFFFF
          line-height 34px
          letter-spacing 2px
          text-align center
          cursor pointer
          transition all 0.3s
          &:hover
            background #FFFFFF
            color #c8161d
  .news
    display flex
    flex-wrap wrap
    margin-top 30px
    >>> .news-item
      &:not(:nth-of-type(3n+1))
        margin-left 66px
      &:nth-of-type(n+4)
        margin-top 40px
  .entitys
    padding 0 140px
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px 20px;
    margin-top 20px
.previous-swiper
  width 100%
  height 360px
  margin-top 30px
  .swiper-slide
    width 540px
    height 360px
  .previous-item
    width 100%
    height 100%
    img
      width 100%
      height 100%
</style>
